<template>
  <button
    type="button"
    class="sc3-button sc3-button-small sc3-button-grey sc3-button-square-medium-height"
    :class="{
      'sc3-button-bottom-aligned': isFirstRow,
      'sc3-button-top-aligned': !isFirstRow
    }"
    :title="`Move ${isUp ? 'Up' : 'Down'}`"
    @click="reorder()"
  ><i :class="isUp ? `fas fa-fw fa-chevron-up` : `fas fa-fw fa-chevron-down`"></i></button>
</template>

<script lang="ts" setup>
  import { toRefs } from 'vue';

  const props = defineProps<{
    id: number;
    isUp: boolean;
    isFirstRow: boolean;
  }>();
  const { id, isUp, isFirstRow } = toRefs(props);

  const emit = defineEmits<{
    (e: 'reorder', id: number): void;
  }>();

  function reorder() {
    emit('reorder', id.value);
  }
</script>
